import React from "react";
import { Pane, Button, AccordionSet, Accordion, Checkbox, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import NavComponent from "./NavComponent";
import { PublisherRegistrationAgencyEnum } from "../types/Api";
var AgencyPrefixFilterPane = function (_a) {
    var filterPaneIsVisible = _a.filterPaneIsVisible, isAnyFilterActive = _a.isAnyFilterActive, onClearFilters = _a.onClearFilters, filters = _a.filters, onAgencyChange = _a.onAgencyChange;
    var formatMessage = useIntl().formatMessage;
    if (!filterPaneIsVisible)
        return null;
    return (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({ id: "ui-br-agency.navigation.pane.title" }) },
        React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
            React.createElement(NavComponent, null),
            React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !isAnyFilterActive, marginBottom0: true, onClick: onClearFilters },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.resetAll" })),
            React.createElement(AccordionSet, null,
                React.createElement(Accordion, { label: formatMessage({
                        id: "ui-br-agency.agency-prefix.accordions.label.type",
                    }), separator: false }, Object.values(PublisherRegistrationAgencyEnum).map(function (agency) { return (React.createElement(Checkbox, { key: agency, label: agency, checked: filters.agencies.includes(agency), onChange: function () { return onAgencyChange(agency); } })); }))))));
};
export default AgencyPrefixFilterPane;
